import styles from "./InlineSpinner.module.css";

interface InlineSpinnerProps {
  size?: number;
}

export function InlineSpinner({ size = 16 }: InlineSpinnerProps) {
  return (
    <span
      className={styles.spinner}
      style={{ width: size, height: size }}
      aria-label="Loading"
    />
  );
}